import axios from "axios";
import { USER_PORTAL_URL } from "../../constants/keycloakCredentials";
import { decorateApiError } from "../../utils/apiErrorUtils";

const UserInstance = axios.create({
  baseURL: USER_PORTAL_URL,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,OPTIONS",
  },
});

UserInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("authToken");
  if (token) {
    config.headers.Authorization = token;
  } else {
    delete config.headers.Authorization;
  }
  return config;
});

UserInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(decorateApiError(error)),
);

export default UserInstance;
